import React from 'react'
import Logo from "../../Logo"
import MenuInicioSuscrito from "../../../pages/inicioSuscrito/MenuInicioSuscrito"
import Redes from "../../Redes"
import "../../../../styles/registrado/noticias/slideNoticias1.css"
import Footer from "../../../Reutilizables/Footer"

function SlideNoticias1() {
  return (
    <>
      <Logo/>
      <MenuInicioSuscrito />
      <Redes />
      <div className="body-slide1-noticias">
        <section className='section1'>
          <h3 className='subtittle-slide1'>1. El hecho imponible</h3>
          <div className='text-slide1'>
            Es la acción que origina el nacimiento de la obligación tributaria.<br/>

            Por ejemplo comprar un producto, tomar un avión o cenar en un restaurante constituyen hechos imponibles ya que realizar estas 
            acciones tiene como consecuencia el pago de un impuesto como puede ser el IVA.
          </div>
        </section>

        <section className='section2'>
          <h3 className='subtittle-slide1'>2. La base imponible</h3>
          <div className='text-slide1'>
            Es la cuantificación económica del hecho imponible según la regulación establecida para cada tributo. Por ejemplo, en el impuesto
            sobre la renta de las personas físicas, la base imponible está constituida por la renta del contribuyente, la cual se obtiene 
            sumando los ingresos que recibe por todos los conceptos y restando los gastos necesarios para obtenerlos.
          </div>
        </section>

        <section className='section3'>
          <h3 className='subtittle-slide1'>3. La base liquidable</h3>
          <div className='text-slide1'>
            Es la cantidad que resulta después de restar a la base imponible las reducciones que estén previstas en la normativa de cada 
            tributo. En el caso de que no exista ninguna reducción, la base liquidable coincidirá con la base imponible.
          </div>
        </section>

        <section className='section4'>
          <h3 className='subtittle-slide1'>4. El tipo impositivo</h3>
          <div className='text-slide1'>
            También denominado tipo de gravamen es un porcentaje que se aplica a la base liquidable para obtener la cuota tributaria. 
            Por ejemplo el tipo impositivo general del IVA en España es del 21%.
          </div>
        </section>

        <section className='section5'>
          <h3 className='subtittle-slide1'>5. La cuota tributaria</h3>
          <div className='text-slide1'>
            Esta se obtiene como resultado de aplicar el tipo impositivo a la base liquidable. Por ejemplo si decides comprar una televisión
            que tiene un valor de 100 euros y cuenta con un IVA del 21 %, la cuota tributaria que deberás pagar es de 21 euros, es decir
            acabaras pagando por el televisor 121 euros.
          </div>
        </section>

        <section className='section6'>
          <h3 className='subtittle-slide1'>6. La cuota líquida o deuda tributaria</h3>
          <div className='text-slide1'>
            Es la cantidad que se debe pagar a la Administración pública correspondiente. Es el resultado de sumar o restar a la cuota 
            tributaria, los recargos y deducciones establecidos por la norma del tributo. En el caso de que no existan recargos y deducciones, 
            la cuota líquida coincidirá con la cuota tributaria.
          </div>
        </section>

        <section className='section7'>
          <h3 className='subtittle-slide1'>7. Cuota diferencial</h3>
          <div className='text-slide1'>
            En algunos impuestos como el IRPF, a la cuota líquida habrá que restar las retenciones e ingresos a cuenta para obtener 
            la cuota diferencial, cuyo resultado puede ser positivo en cuyo caso habrá que pagar a Hacienda, o negativo en cuyo caso 
            será Hacienda la que nos pague a nosotros.
          </div>
        </section>

        <section className='section8'>
          <h3 className='subtittle-slide1'>8. Contribuyente</h3>
          <div className='text-slide1'>
            Es la persona física o jurídica sobre la que recae el impuesto.
          </div>
        </section>

        <section className='section9'>
          <h3 className='subtittle-slide1'>9. Sujeto pasivo</h3>
          <div className='text-slide1'>
            Es la persona natural o jurídica que según la ley queda obligada a cumplir las prestaciones tributarias y las obligaciones 
            materiales o formales. Esta figura puede coincidir con la figura del contribuyente, como sucede en el impuesto sobre la renta 
            de las personas físicas o IRPF o puede no coincidir, como ocurre con el impuesto sobre el valor añadido o IVA, donde el 
            contribuyente es el consumidor final pero el sujeto pasivo es la empresa o profesional que realiza la entrega de bienes o 
            prestación de servicios y la cual es la encargada de reintegrar el importe del IVA a la administración pública.
          </div>
        </section>

        <section className='section10'>
          <h3 className='subtittle-slide1'>10. Periodo impositivo</h3>
          <div className='text-slide1'>
            Se define como el plazo de tiempo que se corresponde con la liquidación del impuesto. En el impuesto sobre sociedades 
            por ejemplo, este periodo coincide con el año natural.
          </div>
        </section>
      </div>
      <Footer />
    </>
  )
}

export default SlideNoticias1
